import { c as _c } from "react/compiler-runtime";
import { TerraLink } from "../../component/TerraLink/TerraLink";
import { IconTextNoodle } from "../../component/IconTextNoodle/IconTextNoodle";
import { CommonDescription } from "../../component/CommonDescription/CommonDescription";
import { darkTextureWrapper, colorSettingDetection, renderHeaderConditionally } from "../../utils/functions";
import { layoutHeaderClasses, layoutHeaderBigClasses, layoutSubheaderClasses, layoutEyebrowClasses } from "@/components/tailwindHelpers";
export interface LayoutItemizedList {
  eyebrow?: string;
  header?: string;
  headerElement?: "h1" | "h2";
  subheader?: string;
  description?: string;
  iconTextItems?: IconTextNoodle[];
  isAccordion?: boolean;
  isIconVisible?: boolean;
  buttons?: TerraLink[];
  presetTheme?: "t2-theme-one" | "t2-theme-two" | "t2-theme-three" | "t2-theme-four" | "t2-theme-five" | "t2-theme-six" | "t2-theme-seven";
  isHeaderBig?: boolean;
  isWrapped?: boolean;
}
const NOODLE_BASE = "flex basis-full max-w-full px-2.5 ml-0 min-lg:basis-1/3 min-lg:max-w-[33.333%]";
const EVEN_NOODLE = `${NOODLE_BASE} min-lg:ml-[8.333%]`;
const ODD_NOODLE = `${NOODLE_BASE} min-lg:ml-[16.666%]`;
const NOODLE_HEADER_OVERRIDES = ["[&_.t2-icon-text-noodle__description+.t2-icon-text-noodle__link]:mt-6", "[&_.t2-icon-text-noodle__header--mobile]:text-gray-m9", "[&_.t2-icon-text-noodle__header--mobile]:text-xl", "[&_.t2-icon-text-noodle__header--mobile]:font-bold", "[&_.t2-icon-text-noodle__header--mobile]:leading-relaxed", "[&_.t2-icon-text-noodle__header--mobile]:no-underline", "[&_.t2-icon-text-noodle__header--mobile]:mt-4", "[&_.t2-icon-text-noodle__header--mobile]:flex", "[&_.t2-icon-text-noodle__header--mobile]:items-center", "[&_.t2-icon-text-noodle__header--mobile]:gap-4", "[&_.t2-icon-text-noodle__header--mobile:hover]:underline", "[&_.t2-icon-text-noodle__header--mobile>span]:flex", "[&_.t2-icon-text-noodle__header--mobile>span]:items-center", "t2-dark:[&_.t2-icon-text-noodle__header--mobile]:text-white"].join(" ");
export const LayoutItemizedList = t0 => {
  const $ = _c(53);
  const {
    eyebrow,
    header,
    headerElement: t1,
    subheader,
    description,
    iconTextItems,
    presetTheme,
    isIconVisible: t2,
    isHeaderBig,
    isWrapped,
    buttons
  } = t0;
  const headerElement = t1 === undefined ? "h2" : t1;
  const isIconVisible = t2 === undefined ? true : t2;
  const wrapperClasses = isWrapped ? "w-full px-5 lg:px-20 m-auto max-w-[1440px]" : "";
  let t10;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== description || $[1] !== eyebrow || $[2] !== header || $[3] !== headerElement || $[4] !== iconTextItems || $[5] !== isHeaderBig || $[6] !== isIconVisible || $[7] !== presetTheme || $[8] !== subheader || $[9] !== wrapperClasses) {
    const colorSetting = colorSettingDetection(presetTheme || "");
    const mainClasses = `py-[100px] ${presetTheme || ""} ${colorSetting} ${NOODLE_HEADER_OVERRIDES}`;
    const headerClasses = isHeaderBig ? layoutHeaderBigClasses : layoutHeaderClasses;
    const t11 = header || "";
    let t12;
    if ($[18] !== headerClasses || $[19] !== headerElement || $[20] !== t11) {
      t12 = renderHeaderConditionally(headerClasses, t11, headerElement);
      $[18] = headerClasses;
      $[19] = headerElement;
      $[20] = t11;
      $[21] = t12;
    } else {
      t12 = $[21];
    }
    const finalHeader = t12;
    const t13 = presetTheme || "";
    let t14;
    if ($[22] !== t13) {
      t14 = darkTextureWrapper(t13);
      $[22] = t13;
      $[23] = t14;
    } else {
      t14 = $[23];
    }
    const componentStyles = t14;
    t8 = mainClasses;
    t9 = componentStyles;
    t10 = "layout-itemized-list";
    t7 = wrapperClasses;
    t5 = "t2-layout__content";
    let t15;
    if ($[24] !== eyebrow) {
      t15 = eyebrow && <div className={layoutEyebrowClasses}>{eyebrow}</div>;
      $[24] = eyebrow;
      $[25] = t15;
    } else {
      t15 = $[25];
    }
    let t16;
    if ($[26] !== subheader) {
      t16 = subheader && <div className={layoutSubheaderClasses}>{subheader}</div>;
      $[26] = subheader;
      $[27] = t16;
    } else {
      t16 = $[27];
    }
    let t17;
    if ($[28] !== description) {
      t17 = description && <CommonDescription description={description} className="t2-lo-itemized-list__description t2-layout__description" />;
      $[28] = description;
      $[29] = t17;
    } else {
      t17 = $[29];
    }
    if ($[30] !== finalHeader || $[31] !== t15 || $[32] !== t16 || $[33] !== t17) {
      t6 = <div className="flex flex-wrap -mx-2.5 pb-20"><div className="basis-full max-w-full px-2.5 ml-0 min-lg:basis-2/3 min-lg:max-w-[66.666%]">{t15}{finalHeader}{t16}{t17}</div></div>;
      $[30] = finalHeader;
      $[31] = t15;
      $[32] = t16;
      $[33] = t17;
      $[34] = t6;
    } else {
      t6 = $[34];
    }
    t3 = "flex flex-wrap -mx-2.5 gap-y-24";
    t4 = iconTextItems && iconTextItems.map((item, index) => <div key={`icon-text-noodle-${index}`} className={index % 2 === 0 ? EVEN_NOODLE : ODD_NOODLE} data-testid="itemized-list-item"><IconTextNoodle {...item} isIconVisible={isIconVisible} isDarkTheme={colorSetting?.includes("dark") ? true : false} /></div>);
    $[0] = description;
    $[1] = eyebrow;
    $[2] = header;
    $[3] = headerElement;
    $[4] = iconTextItems;
    $[5] = isHeaderBig;
    $[6] = isIconVisible;
    $[7] = presetTheme;
    $[8] = subheader;
    $[9] = wrapperClasses;
    $[10] = t10;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t10 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  let t11;
  if ($[35] !== t3 || $[36] !== t4) {
    t11 = <div><div className={t3}>{t4}</div></div>;
    $[35] = t3;
    $[36] = t4;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== buttons) {
    t12 = buttons && <div className="justify-center pt-12 flex flex-wrap gap-x-4 gap-y-7">{buttons.map(_temp)}</div>;
    $[38] = buttons;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  if ($[40] !== t11 || $[41] !== t12 || $[42] !== t5 || $[43] !== t6) {
    t13 = <div className={t5}>{t6}{t11}{t12}</div>;
    $[40] = t11;
    $[41] = t12;
    $[42] = t5;
    $[43] = t6;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  let t14;
  if ($[45] !== t13 || $[46] !== t7) {
    t14 = <div className={t7}>{t13}</div>;
    $[45] = t13;
    $[46] = t7;
    $[47] = t14;
  } else {
    t14 = $[47];
  }
  let t15;
  if ($[48] !== t10 || $[49] !== t14 || $[50] !== t8 || $[51] !== t9) {
    t15 = <div className={t8} style={t9} data-testid={t10}>{t14}</div>;
    $[48] = t10;
    $[49] = t14;
    $[50] = t8;
    $[51] = t9;
    $[52] = t15;
  } else {
    t15 = $[52];
  }
  return t15;
};
function _temp(btn, index_0) {
  return <TerraLink key={index_0} {...btn} />;
}